<template>
  <div class="col-12">
    <Search
      :title="$lang.daily_working_list_title"
      :allowFields="$lang.daily_working_allow_fields"
      :hiddenFields="hiddenFields"
      :url="url"
      :allowCollapse="false"
      :visibleSearch="true"
      :visibleSettings="true"
      :visibleExport="true"
      :visibleFilters="true"
      :visibleViewCount="true"
      :allowEdit="false"
      :filterCatch="filterCatch"
      :showTotals="true"
      :openNewTab="true"
      :showCheckBox="true"
      :handleCheckBoxCondition="() => true"
      :defaultViewCount="50"
      removeModalSize="lg"
      addModalSize="lg"
      :dynamicButtons="dynamicButtons"
      :extraButtons="extraButtons"
      ref="search"
      :visibleAdd="isAdmin(permissions, ['admin'])"
      @getPermisson="updatePermissions"
      @rowSelected="rowSelected"
      @rowAllItems="rowAllItems"
      @getOther="updateOtherData"
    >
      <template #alerts>
        <div class="mb-2">
          {{ $lang.salary_total }}:
          <strong class="text-secondary">
            {{ priceFormat(pathOr("", ["salary_total"], otherData)) }}
            {{ $lang.rial }}
          </strong>
        </div>
      </template>
      <template slot="addModal" slot-scope="search">
        <AddDailyWorking @close="search.close" @getData="getData" />
      </template>
    </Search>
    <b-modal v-model="editModal" size="lg" hide-footer hide-header>
      <EditDailyWorking
        :id="editId"
        @close="closeEditModal"
        @getData="getData"
      />
    </b-modal>
    <Confirm
      v-model="checkedConfirmData.show"
      :title="$lang.checking_daily_working"
      :description="$lang.are_you_sure_selected"
      :loading="checkedConfirmData.loading"
      :loadingSpinnerText="$lang.updating_data"
      :ok-title="$lang.yes"
      :cancel-title="$lang.no"
      headerVariant="primary"
      dynamicClass=""
      @ok="patchDailyWorking"
      @cancel="closeCheckedConfirmData"
    />
  </div>
</template>

<script>
import Search from "@/components/base/search";
import AddDailyWorking from "./addDailyWorking.vue";
import EditDailyWorking from "./editDailyWorking.vue";
import Confirm from "@/components/base/confirm";
import { pathOr } from "ramda";
import {
  isAdmin,
  generateApiUrl,
  goToRoute,
  priceFormat,
} from "@/shared/utils";
import { computed } from "vue";
import filterMethods from "@/mixin/filterMethods.js";

export default {
  extends: filterMethods,
  components: {
    Search,
    AddDailyWorking,
    EditDailyWorking,
    Confirm,
  },
  provide() {
    /* guidance: provide this data to all deep child components */
    return {
      PERMISSIONS: computed(() => this.permissions),
      COOPERATION_DATE: computed(() => null),
      WORK_ORDER: computed(() => null),
    };
  },
  data() {
    return {
      buttons: [
        {
          name: "edit",
          click: this.showEditModal,
          showIcon: true,
        },
        {
          name: "view",
          click: this.showEditModal,
          showIcon: true,
        },
        {
          name: "delete",
          showIcon: false,
        },
      ],
      permissions: [],
      otherData: null,
      hiddenFields: ["created_by", "created_at.jalali"],
      editModal: false,
      editId: null,
      filterCatch: true,
      url: null,
      orderId: this.$route.params.id,
      checkedItems: [],
      checkedConfirmData: {
        show: false,
        loading: false,
      },
    };
  },
  computed: {
    extraButtons() {
      return [
        {
          name: "backComponentSearchFilter",
          condition: this.checkedItems.length,
          title: this.$lang.checking_daily_working,
          click: this.patchDailyWorking,
          loading: this.checkedConfirmData.loading,
          iconName: "shield-check-outline",
        },
      ];
    },
  },
  watch: {
    orderId: {
      immediate: true,
      handler(value) {
        if (value) {
          this.filterCatch = false;
        }
        const queryString = value ? { search_txt_work_order_id: value } : {};
        this.url = generateApiUrl(
          ["cooperation", "daily_working"],
          [],
          queryString
        );
      },
    },
  },
  methods: {
    pathOr,
    isAdmin,
    generateApiUrl,
    goToRoute,
    priceFormat,
    dynamicButtons(item) {
      return this.buttons.map((button) => {
        return {
          ...button,
          showIcon: button.showIcon || !pathOr(false, ["selected"], item),
          name:
            button.name === "edit" && pathOr(false, ["selected"], item)
              ? "editView"
              : button.name,
        };
      });
    },
    getData() {
      this.$refs.search.getItems();
    },
    updatePermissions(permissions) {
      this.permissions = permissions;
    },
    updateOtherData(otherData) {
      this.otherData = otherData;
    },
    showEditModal(item) {
      this.editId = pathOr(null, ["id"], item);
      this.editModal = true;
    },
    closeEditModal() {
      this.editId = null;
      this.editModal = false;
    },
    rowSelected(item, callback) {
      const alreadyExist = this.checkedItems.some((x) => x.id == item.id);
      if (alreadyExist) {
        this.checkedItems = this.checkedItems.filter((x) => {
          return x.id !== item.id;
        });
      }
      const renderedItem = {
        id: item.id,
        is_checked: +item.selected,
      };
      this.checkedItems.push(renderedItem);
    },
    rowAllItems(items) {
      this.checkedItems = items.map((item) => {
        return {
          id: item.id,
          is_checked: +item.selected,
        };
      });
    },
    showCheckedConfirmData() {
      this.checkedConfirmData.show = true;
    },
    closeCheckedConfirmData() {
      this.checkedConfirmData.show = false;
      this.getData();
    },
    async patchDailyWorking() {
      try {
        this.checkedConfirmData.loading = true;
        const url = generateApiUrl(["cooperation", "daily_working"]);
        const payload = {
          records: [...this.checkedItems],
        };
        const response = await this.$httpService.patch(url, payload);
        this.$notify.success(response.data.message);
        this.checkedConfirmData.show = false;
        this.checkedItems = [];
        this.getData();
      } catch (error) {
        this.generateError(error);
      } finally {
        this.checkedConfirmData.loading = false;
      }
    },
  },
};
</script>
